import React, { useEffect, useState } from 'react';
import { Animate } from 'react-move';
import { ReactElement } from 'react';

interface AnimatedProgressProviderProps {
  valueStart: number;
  valueEnd: number;
  duration: number;
  easingFunction: (normalizedTime: number) => number;
  repeat: boolean;
  children: (value: number) => ReactElement;
}

export const AnimatedProgressProvider: React.FC<AnimatedProgressProviderProps> = ({
  valueStart,
  valueEnd,
  duration,
  easingFunction,
  repeat,
  children,
}) => {
  const [isAnimated, setIsAnimated] = useState(false);

  useEffect(() => {
    if (repeat) {
      setIsAnimated(true);
    }
  }, [repeat]);

  return (
    <Animate
      start={() => ({
        value: valueStart,
      })}
      update={() => ({
        value: [isAnimated ? valueEnd : valueStart],
        timing: {
          duration: duration * 1000,
          ease: easingFunction,
        },
        events: {
          end: () => {
            if (repeat) {
              setIsAnimated(false);
              setTimeout(() => setIsAnimated(true), 0);
            }
          },
        },
      })}
    >
      {({ value }) => children(value)}
    </Animate>
  );
};